module.exports = __webpack_public_path__ + "img/icon-laecheln.ab97df90.svg";